import React from "react";

import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import CardProfile from "../Pages/CardProfile/CardProfile";

import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Cardprofiletheme() {
  return (
    <>
      <Header />
      <CardProfile />
      <Latestupdate />
      <Footer />
    </>
  );
}
